import useVippsLogin from './useVippsLogin'

export default useVippsLogin
